import React, {useMemo} from "react";
import {StatusBadge, StatusBadgeProps} from "~/apps/core/ui/StatusBadge";
import {ShortCargo} from "~/apps/packages/cargos/queries";
import {getStatusColor} from "~/apps/packages/cargos/utils";


export type CargoStatusBadgeProps = Omit<StatusBadgeProps<ShortCargo["status"]>, "badgeColor">;


export const CargoStatusBadge = (props: CargoStatusBadgeProps) => {
    const {children, ...otherProps} = props;
    const status = useMemo(() => children, [children]);
    const badgeColor = useMemo(() => getStatusColor(status), [status]);

    return (
        <StatusBadge {...otherProps} badgeColor={badgeColor} outlined={false}>
            {status}
        </StatusBadge>
    )
}